import styled, { css } from 'styled-components';
import Image from '@components/image';
import LinkComponent from '@components/link';
import { headerHeight } from '@components/header/header.styled';
import { IllustrationHeroProps } from './index';

export const EyebrowWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    column-gap: 0.5rem;

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      justify-content: center;
    }

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      column-gap: 0.375rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.sm}) {
      justify-content: flex-start;
    }
  `}
`;

export const StyledImage = styled(Image)`
  z-index: 1;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
`;

export const Content = styled.div<IllustrationHeroProps>`
  ${({ theme, image }) => css`
    position: relative;
    display: flex;
    flex-direction: column;
    row-gap: 2.5rem;
    z-index: 1;
    width: 100%;
    max-width: 36rem;

    ${image?.url
      ? css`
          @media only screen and (max-width: ${theme.breakpoints.lg}) {
            align-items: center;
          }

          @media only screen and (max-width: ${theme.breakpoints.sm}) {
            align-items: flex-start;
            row-gap: 2rem;
          }
        `
      : css`
          max-width: 52rem;
          align-items: center;
        `}
  `}
`;

export const Header = styled.header`
  ${({ theme }) => {
    return css`
      display: flex;
      position: relative;
      width: 100%;
      margin: 0;
      background-color: ${theme.backgroundColors.primary};
      padding-top: ${headerHeight};

      @media only screen and (max-width: ${theme.breakpoints.lg}) {
        padding-top: 5rem;
      }

      @media only screen and (max-width: ${theme.breakpoints.md}) {
        padding-top: 4rem;
      }
    `;
  }}
`;

export const StyledWrapper = styled.div<IllustrationHeroProps>`
  ${({ theme, image }) => css`
    display: flex;
    align-items: center;
    padding: 4rem 0;
    background-color: ${theme.backgroundColors.primary};
    gap: 4rem;
    ${image?.url &&
    css`
      max-width: 38rem;
    `}

    @media only screen and (max-width: ${theme.breakpoints.lg}) {
      padding: 3rem 0;
      gap: 2rem;
    }

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      padding: 2.5rem 0;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
    }
  `}
`;

export const LinkButton = styled(LinkComponent)<IllustrationHeroProps>`
  ${({ theme }) => css`
    &:hover {
      background-color: ${theme.colors.secondary};
      color: ${theme.colors.white};
    }
  `}
`;

export const ImageWrapper = styled.div`
  ${({ theme }) => css`
    gap: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      justify-content: flex-start;
    }
  `}
`;
